export function degreesToCompass(deg?: number): string {
  if (deg === undefined || deg === null) return '—';
  const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  return dirs[Math.round(deg / 45) % 8];
}

export function formatFreq(mhz?: number): string {
  if (!mhz) return '—';
  return mhz >= 1000 ? `${(mhz / 1000).toFixed(1)} GHz` : `${mhz} MHz`;
}

export function formatDistance(m?: number): string {
  if (m === undefined || m === null) return '—';
  return m >= 1000 ? `${(m / 1000).toFixed(1)} km` : `${Math.round(m)} m`;
}

export function formatSpeed(ms?: number): string {
  if (ms === undefined || ms === null) return '—';
  return `${ms.toFixed(1)} m/s`;
}

export function sensorColor(type?: string): string {
  switch (type) {
    case 'CRPC':     return '#4fc3f7';
    case 'DRONE_ID': return '#aed581';
    case 'RID':      return '#ffb74d';
    case 'CAMERA':   return '#f48fb1';
    case 'WIDEBAND': return '#ce93d8';
    default:         return '#90a4ae';
  }
}

export function formatTime(iso?: string): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleTimeString();
}

export function formatDate(iso?: string): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString();
}

export function formatDateTime(iso?: string): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString();
}
